var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpAudit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732609330180,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12586,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.8 267.072m-170.88 0a170.88 170.88 0 1 0 341.76 0 170.88 170.88 0 1 0-341.76 0Z",
    fill: "#0052a6",
    "p-id": 12587
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M729.088 646.976c55.424 0 100.48 45.12 100.48 100.48 0 55.424-45.12 100.48-100.48 100.48-55.424 0-100.48-45.12-100.48-100.48a100.544 100.544 0 0 1 100.48-100.48m0-72.128a172.608 172.608 0 1 0 0 345.216 172.608 172.608 0 0 0 0-345.216z",
    fill: "#0052a6",
    "p-id": 12588
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M945.472 927.808a36.224 36.224 0 0 1-20.352-6.272l-87.744-60.096a36.096 36.096 0 0 1 40.704-59.52l87.744 60.096a36.096 36.096 0 0 1-20.352 65.792zM503.04 745.984c0-91.648 50.56-170.688 124.8-213.184a385.28 385.28 0 0 0-193.984-53.056c-214.784 0-388.736 170.624-391.424 381.952h490.816a242.56 242.56 0 0 1-30.208-115.712z",
    fill: "#0052a6",
    "p-id": 12589
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpAudit);
export default __webpack_public_path__ + "static/media/cpAudit.843c757ee5ac7d5fd2bac4c379a757aa.svg";
export { ForwardRef as ReactComponent };